<script>
  const serverSrc='http://zhsq.chenyingwei.com';
  //const serverSrc='http://videoapi.chenyingwei.com/';
  export default
  {
    serverSrc,//用户地址
  }
</script>
